module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-banner"
    }
  }, [_c('swiper', {
    ref: "myBannerSwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 1),
      expression: "slideToShow === 1"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/geolocal-main-1.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideOne.title')))])])])]), _vm._v(" "), _c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 2),
      expression: "slideToShow === 2"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/geolocal-main-2.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideTwo.title')))])])])]), _vm._v(" "), _c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 3),
      expression: "slideToShow === 3"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/geolocal-main-3.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideThree.title')))])])])]), _vm._v(" "), _c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 4),
      expression: "slideToShow === 4"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/geolocal-main-4.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideFour.title')))])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45396f60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home-geolocal/components/banner-slider/banner-slider.vue
// module id = 302
// module chunks = 0